export default "https://assets.egbcdn.net/assets/packs/_/images/logos/egb-logo-affiliates-547a36f5c63852999e9159e64cdac600.svg";